import { useContext, useMemo } from 'react'
import { DisbursementType } from '../config/registrationConfig'
import GlobalContext from '../context/GlobalContext'

type ReturnProps = {
    loaded: boolean
    disbursementTypes: DisbursementType[]
    getDisbursementType: (id: string) => DisbursementType
}

export default function useDisbursementTypes(): ReturnProps {
    const { disbursementTypes } = useContext(GlobalContext)
    // const { disbursementTypes } = { disbursementTypes: [] }
    const loaded = useMemo(() => disbursementTypes.length > 0, [disbursementTypes])

    const getDisbursementType = (id: string) => (disbursementTypes || []).find(value => value.id === id)

    return { loaded, disbursementTypes, getDisbursementType }
}
